import React from 'react';
import { Icon, USWDSIcons } from '@ver-uds/uswds-react';
import { CategoryType, SubCategoryType, VerificationEnumType } from 'eve-account-client';
import GradingIcon from '@mui/icons-material/Grading';
import SubjectIcon from '@mui/icons-material/Subject';

const iconMap: Record<string, USWDSIcons> = {
  // Groups
  'Federal Contractor': 'people',
  Government: 'account_balance',

  // Categories and Sub-categories
  [SubCategoryType.NONEOFTHEABOVE]: 'work',
  [SubCategoryType.SURETY]: 'attach_money',
  [SubCategoryType.STATEORLOCALGOVT]: 'account_balance',
  [SubCategoryType.NATIVEAMERICANTRIBE]: 'flag',
  [SubCategoryType.INSTITUTEOFHIGHERLEARNING]: 'school',
  [CategoryType.NONEOFTHEABOVE]: 'work',
  [CategoryType.LOCALGOVERNMENT]: 'location_on',
  [CategoryType.STATEGOVERNMENT]: 'location_city',
  [CategoryType.FEDERALGOVERNMENT]: 'account_balance',
  [CategoryType.AIRPORTOPERATORS]: 'flight',

  // Verification types
  [VerificationEnumType.ENTIREWORKFORCE]: 'groups',
  [VerificationEnumType.ALLNEWANDEXISTINGFEDCONTHIRE]: 'people',
  [VerificationEnumType.NEWANDEXISTINGHIREONFEDCONT]: 'group_add',
  [VerificationEnumType.FEDCONTEMPLOYEESONLY]: 'person',
};

type CategoryIconProps = {
  icon: keyof typeof iconMap;
};

const CategoryIcon = ({ icon }: CategoryIconProps): JSX.Element => {
  // UX team decided to use Material icons for these two category types
  switch (icon) {
    case CategoryType.FEDERALCONTRACTOR:
      return <GradingIcon fontSize="large" />;
    case CategoryType.FEDERALCONTRACTORWOEVCLAUSE:
      return <SubjectIcon fontSize="large" />;
    default:
      return <Icon name={iconMap[icon]} size={4} />;
  }
};

export default CategoryIcon;
